import React from 'react';

const FALLBACK_PRIMARY = '#1DA1FF';

function colorInputValue(value) {
  const raw = String(value || '').trim();
  if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw)) {
    if (raw.length === 4) {
      return `#${raw[1]}${raw[1]}${raw[2]}${raw[2]}${raw[3]}${raw[3]}`;
    }
    return raw;
  }
  return FALLBACK_PRIMARY;
}

export function BrandFields({ formData, setField, hint }) {
  return (
    <>
      <h3 className="form-section-title">Brand & theme</h3>
      {hint ? <p className="form-hint" style={{ marginTop: 0 }}>{hint}</p> : null}
      <p className="form-hint">
        Leave a field empty to inherit the existing Inaiy blue theme (`{FALLBACK_PRIMARY}`), then partner, then this workspace.
      </p>
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">App name</label>
          <input
            className="form-input"
            value={formData.appName}
            onChange={(e) => setField('appName', e.target.value)}
            placeholder="Inaiy"
          />
        </div>
        <div className="form-group">
          <label className="form-label">Primary color</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="color"
              value={colorInputValue(formData.primaryColor)}
              onChange={(e) => setField('primaryColor', e.target.value.toUpperCase())}
              aria-label="Pick primary color"
              style={{ width: 44, height: 40, padding: 2, border: '1px solid var(--color-border)', borderRadius: 8, background: 'transparent' }}
            />
            <input
              className="form-input"
              value={formData.primaryColor}
              onChange={(e) => setField('primaryColor', e.target.value)}
              placeholder={FALLBACK_PRIMARY}
            />
          </div>
        </div>
      </div>
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">Secondary color</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="color"
              value={colorInputValue(formData.secondaryColor || '#0284C7')}
              onChange={(e) => setField('secondaryColor', e.target.value.toUpperCase())}
              aria-label="Pick secondary color"
              style={{ width: 44, height: 40, padding: 2, border: '1px solid var(--color-border)', borderRadius: 8, background: 'transparent' }}
            />
            <input
              className="form-input"
              value={formData.secondaryColor}
              onChange={(e) => setField('secondaryColor', e.target.value)}
              placeholder="#0284C7"
            />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Support URL</label>
          <input
            className="form-input"
            value={formData.supportUrl}
            onChange={(e) => setField('supportUrl', e.target.value)}
            placeholder="https://help.example.com"
          />
        </div>
      </div>
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">Logo URL</label>
          <input className="form-input" value={formData.logoUrl} onChange={(e) => setField('logoUrl', e.target.value)} placeholder="https://..." />
        </div>
        <div className="form-group">
          <label className="form-label">Logo mark URL</label>
          <input className="form-input" value={formData.logoMarkUrl} onChange={(e) => setField('logoMarkUrl', e.target.value)} placeholder="Square icon" />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Favicon URL</label>
        <input className="form-input" value={formData.faviconUrl} onChange={(e) => setField('faviconUrl', e.target.value)} placeholder="https://..." />
      </div>
      <div className="form-group">
        <label className="form-label">Login headline</label>
        <input className="form-input" value={formData.loginHeadline} onChange={(e) => setField('loginHeadline', e.target.value)} placeholder="One platform. Every conversation." />
      </div>
      <div className="form-group">
        <label className="form-label">Login subhead</label>
        <textarea className="form-input" rows={2} value={formData.loginSubhead} onChange={(e) => setField('loginSubhead', e.target.value)} />
      </div>
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">Support email</label>
          <input className="form-input" type="email" value={formData.supportEmail} onChange={(e) => setField('supportEmail', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Email from name</label>
          <input className="form-input" value={formData.emailFromName} onChange={(e) => setField('emailFromName', e.target.value)} placeholder="Inaiy" />
        </div>
      </div>
      <label className="form-check">
        <input
          type="checkbox"
          checked={Boolean(formData.hidePoweredBy)}
          onChange={(e) => setField('hidePoweredBy', e.target.checked)}
        />
        Hide “Powered by Inaiy”
      </label>
      {(formData.logoUrl || formData.appName || formData.primaryColor) && (
        <div
          className="card"
          style={{
            marginTop: 12,
            padding: 16,
            borderLeft: `4px solid ${colorInputValue(formData.primaryColor)}`,
          }}
        >
          <div className="stat-card__label">Preview</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
            {formData.logoUrl ? (
              <img src={formData.logoUrl} alt="" style={{ height: 32, objectFit: 'contain' }} />
            ) : null}
            <strong>{formData.appName || 'Inaiy'}</strong>
            <span
              style={{
                display: 'inline-block',
                width: 16,
                height: 16,
                borderRadius: 999,
                background: colorInputValue(formData.primaryColor),
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
